<template>
	<div>
		<div style="margin-top: 25px;font-size: 20px;"><span>管理员</span></div>
		<div style="margin-top: 15px;">
			<el-row :gutter="12" type="flex" justify="right">
				<el-card shadow="hover" style="width: 350px;" :body-style="{ padding: '0px', height:'125px'}">
					<div style="width: 100%;height: 100%;">
						<div style="width: 100px;float: left;text-align: center;">
							<img :src="managerAvatar" style="width: 72px;height: 72px;margin-top: 24px;"/>
						</div>
						<div style="width: 240px;float: left;margin-left: 8px;">
							<div style="text-align: right;font-size: 24px;margin-right: 10px;margin-top: 5px;">
								<i class="el-icon-edit-outline" @click="openDialog(managerUid,managerSms)"></i>
							</div>
							<div style="margin-top: 8px;font-weight: bold;">
								<span>{{managerName}}</span>
							</div>
							<div style="font-size: 12px;">
								<span>登录手机号:{{managerPhone}}</span>
							</div>
							<div style="margin-top: 12px;margin-left: 150px;">
								<span style="border: #C8C9CC solid 1px;color: #C8C9CC;border-radius: 5px;padding: 1px;font-size: 14px;" v-if="managerSms">短信</span>
							</div>
						</div>
					</div>
				</el-card>
			</el-row>
		</div>
		<div style="margin-top: 25px;">
			<span style="font-size: 20px;">公司员工</span>
			<el-button type="primary" style="margin-left: 150px;" @click="myDialog1 = true;">新增员工</el-button>
		</div>
		<div style="margin-top: 15px;">
			<el-row :gutter="12">
				<el-col :span="6" v-for="item in employeeList" :key="item.uid">
					<el-card shadow="hover" style="width: 100%;position: relative;margin-top: 15px" :body-style="{ padding: '0px', height:'125px'}">
						<div style="font-size: 24px;position: absolute;right: 5px;top: 5px;cursor: pointer">
							<i class="el-icon-close" style="margin-left: 5px;" @click="deleteItem(item.uid)"></i>
						</div>
						<div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center">
							<div style="width: 72px;height:72px;float: left;text-align: center;">
								<img :src="item.avatar" style="width: 72px;height: 72px;"/>
							</div>
							<div style="float: left;margin-left: 15px;">
								<div style="margin-top: 8px;font-weight: bold;">
									<span>{{item.nickname}}</span>
								</div>
								<div style="font-size: 12px;">
									<span>登录手机号:{{item.username}}</span>
								</div>
							</div>
						</div>
					</el-card>
				</el-col>
			</el-row>
			<el-pagination background
				style="text-align:center;margin-top: 35px;margin-bottom: 65px;"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-sizes="[8, 16, 64, 128]"
				:page-size="pageSize" 
				layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>
		<el-dialog title="员工权限设置" :visible.sync="myDialog" width="350px" :before-close="handleClose" :close-on-click-modal="false">
			<div style="font-size: 16px;font-weight: bold;">
				<span>短信通知</span>
			</div>
			<div style="margin: 10px;font-size: 16px;">
				<el-radio v-model="smsSelect" label="1">是</el-radio>
				<el-radio v-model="smsSelect" label="0">否</el-radio>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="myDialog = false">取 消</el-button>
    			<el-button type="primary" @click="setSmsSend">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="新增员工账号" :visible.sync="myDialog1" width="350px" :before-close="handleClose">
			<div>
				<span style="font-size: 16px;"><span style="font-weight: bold;">公司名</span>:{{managerCompony}}</span>
			</div>
			<div style="margin-top: 12px;">
				<el-input v-model="phone" placeholder="请输入员工注册手机号"></el-input>
			</div>
			<div style="font-size: 16px;font-weight: bold;margin-top: 12px;">
				<span>短信通知</span>
			</div>
			<div style="margin: 10px;font-size: 16px;">
				<el-radio v-model="smsSelect" label="1">是</el-radio>
				<el-radio v-model="smsSelect" label="0">否</el-radio>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="myDialog1 = false">取 消</el-button>
    			<el-button type="primary" @click="newEmployee">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'accountCenter',
  components: {
  },
  data() {
    return {
    	managerUid:'',
    	managerCompony:'',
    	managerAvatar:'',
    	managerName:'',
    	managerPhone:'',
    	managerSms:false,
    	employeeList:[],
    	total: 0,
      	currentPage: 1,
　　  	pageSize: 10,
		myDialog:false,
		smsSelect:'1',
		toUid:'',
		myDialog1:false,
		phone:''
    }
  },
  mounted(){
  	this.initPage();
  	this.updateTable();
  },
  created: function(){
  },
  methods: {
  	initPage(){
  		var thiz = this;
    	axios.get(this.$store.getters.getApiValue+'/srsUser/getMyData.do')
    		.then(function (response) {
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.managerUid = data.data.uid;
			    	thiz.managerAvatar = data.data.avatar;
			    	thiz.managerName = data.data.nickname;
			    	thiz.managerPhone = data.data.mobile;
			    	thiz.managerSms = data.data.sms;
			    	thiz.managerCompony = data.data.companyName;
			    }else{
			    	thiz.$message.error(data.message);
			    }
			}).catch(function (error) {
				thiz.$message.error("系统异常!请与管理员联系!");
			    console.log(error);
			});
  	},
  	handleSizeChange(val) {
      this.pageSize = val;
      this.updateTable();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.updateTable();
    },
    updateTable(){
    	const loading = this.$loading({
          lock: true,
          text: '获取表格数据中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 3000);
    	var thiz = this;
    	axios.get(this.$store.getters.getApiValue+'/srsUser/getStaffList.do')
    		.then(function (response) {
    			loading.close();
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.employeeList = data.data;
			    	thiz.total = data.totalCount;
			    }else{
			    	thiz.$message.error(data.message);
			    }
			}).catch(function (error) {
				loading.close();
				thiz.$message.error("系统异常!请与管理员联系!");
			    console.log(error);
			});
    },
    openDialog(uid,sms){
    	if(sms){
    		this.smsSelect = '1';
    	}else{
    		this.smsSelect = "0";
    	}
    	this.toUid = uid;
    	this.myDialog = true;
    },
    setSmsSend(){
    	var thiz = this;
    	axios.get(this.$store.getters.getApiValue+'/srsUser/setSms.do',{
    		params:{
    			toUid:this.toUid,
    			sms:this.smsSelect
    		}
    	}).then(function (response) {
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.$message.success("设置短信接收成功");
			    	thiz.myDialog = false;
			    	thiz.initPage();
			    	thiz.updateTable();
			    }else{
			    	thiz.$message.error(data.message);
			    }
			}).catch(function (error) {
				thiz.$message.error("系统异常!请与管理员联系!");
			    console.log(error);
			});
    },
    handleClose(){
    	this.toUid = "";
    	this.smsSelect = "1";
    	this.phone = "";
    	this.myDialog = false;
    	this.myDialog1 = false;
    },
    newEmployee(){
    	var thiz = this;
    	axios.get(this.$store.getters.getApiValue+'/srsUser/authorization.do',{
    		params:{
    			phone:this.phone,
    			sms:this.smsSelect
    		}
    	}).then(function (response) {
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.$message.success("新增员工成功");
			    	thiz.myDialog1 = false;
			    	thiz.updateTable();
			    }else{
			    	thiz.$message.error(data.message);
			    }
			}).catch(function (error) {
				thiz.$message.error("系统异常!请与管理员联系!");
			    console.log(error);
			});
    },
    deleteItem(uid){
    	var thiz = this;
    	axios.get(this.$store.getters.getApiValue+'/srsUser/cancelAuthorization.do',{
    		params:{
    			toUid:uid
    		}
    	}).then(function (response) {
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.$message.success("删除员工账号成功");
			    	thiz.updateTable();
			    }else{
			    	thiz.$message.error(data.message);
			    }
			}).catch(function (error) {
				thiz.$message.error("系统异常!请与管理员联系!");
			    console.log(error);
			});
    }
  },
  computed:{
  }
}
</script>

<style>
  .el-table{
  	font-size: 12px;
  	border-bottom: 1px solid #dcd8d8;
  	color: black;
  }
  .buttonClass{
  	font-size: 13px;
  	background-color: #009fe8;
  	color: #FFFFFF;
  }
  .el-table tr th{
  	border-top: 0px;
  	border-left: 0px;
  	border-right: 0px;
  }
  .el-table tr td{
  	border-bottom: 1px solid #dcd8d8;
  }
</style>